import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
// import { Inputfiledsbase } from '../inputfileds/models/inputfiledsbase';
import { Observable, Subscription } from 'rxjs';
// import { sectionView } from '../sections/sections.component';
// import { environment } from './environments/environment';
import { ApiservicesService } from '../../../Services/Apis/apiservices.service';
import { SectionsService } from '../../../inputfileds/form_services/academics/sections/sections.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { QuestionControlService } from '../../../inputfileds/form_services/question-control.service';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
// import { DynamicFormQuestionComponent } from '../../../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { SelectionModel } from '@angular/cdk/collections';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ToastComponent } from '../../../components/toast/toast.component';
import { ToastService } from '../../../Services/toast/toast.service';
import { DynamicFormQuestionComponent } from '../../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { Inputfiledsbase } from '../../../inputfileds/models/inputfiledsbase';
import { environment } from '../../../../environments/environment.prod';
import { ConnectiveservicesService } from '../../../Services/Apis/Connectiveservices/connectiveservices.service';
import { TranslateDirective } from '../../../components/Utilites/Directives/translate.directive';

export interface Student {
  index: number;
  Name: number;
  Dost_ID: string;
  Roll_No: string;
  Email_id: string;
  Department: string;
  Academic_Year: string;
}

@Component({
    selector: 'app-studentpromote',
    imports: [
        FormsModule,
        MatFormFieldModule,
        MatMenuModule,
        MatTableModule,
        MatIconModule,
        RouterModule,
        MatButtonModule,
        MatInputModule,
        ReactiveFormsModule,
        MatExpansionModule,
        // DynamicFormQuestionComponent,
        CommonModule,
        MatTabsModule,
        MatDividerModule,
        MatDialogModule,
        MatCheckboxModule,
        DynamicFormQuestionComponent,
        TranslateDirective
    ],
    providers: [QuestionControlService, ApiservicesService, SectionsService],
    templateUrl: './studentpromote.component.html',
    styleUrl: './studentpromote.component.scss'
})
export class StudentpromoteComponent {

   questions: Inputfiledsbase<string>[] | null = [];
    questions$: Observable<Inputfiledsbase<any>[]> | null | undefined;
    // createsection: Inputfiledsbase<any>[] | null = [];
    // createsection$: Observable<Inputfiledsbase<any>[]> | null | undefined;
    filtersectionForm!: FormGroup;
    // createsectionForm!: FormGroup;
    BatchData: any;
    datasend: any;
    sectionData: any;
    selected_semesterData: any;
    semestesubjectsData: any;
    // dataSource = new MatTableDataSource<sectionView>();
    step = 0;
    onerror = 'https://dbraeiassetmanagement.blob.core.windows.net/dbraimt/prod/home/Placeholders/Placeholder_Image.jpg';
    editsubjectdata: any = null;
    isSubjectEnabled = false;
    assetUrl: string = environment.ASSET_URL;
    assetContainer: string = environment.ASSET_CONTAINER;
    displayedColumns: string[] = ['select', 'Roll_No', 'Name', 'Course_name', 'phone_number', 'email'];
    studentdataSource = new MatTableDataSource<Student>();
    selection = new SelectionModel<Student>(true, []);
    total_count: any;
    paginationdata: any;
    fileName: string | null = null;
    selectedImageUrl: string | ArrayBuffer | null = null;
    file: File | null = null;
    filterdata: any[] | undefined;
    filters: any | undefined;
  
    @ViewChild('createSectionDialog') createSectionDialog!: TemplateRef<any>;
    addingsectionsdata: any | undefined;
    assigntostudenterrormessage: string = '';
  academicsemisterdata: any;
  private serviceSubscription: Subscription | undefined;
    constructor(
      private router: Router,
      private apiservice: ApiservicesService,
      private dialog: MatDialog,
      private _snackBar: MatSnackBar,
      private formService: SectionsService,
      private qcs: QuestionControlService,
      private toastService: ToastService,
      private connectiveservice : ConnectiveservicesService
      // private dialogRef: MatDialogRef<createSectionDialog>
    ) {  }
  
    ngOnInit(): void {
      this.BatchData = history.state?.data;
      console.log("batch data", history.state?.data)
      this.getacademeicyearsemisterdata();

      this.serviceSubscription = this.formService.componentMethodCalled$.subscribe(
        (data) => {
          this.getstudentdetails(data);
        }
      );
    }
  
    getacademeicyearsemisterdata(){
      this.apiservice.getrespectiveAcademicSemister(this.BatchData?.id, this.paginationdata).subscribe((res: any) => {
        this.academicsemisterdata = res;
        this.questions$ = this.formService.getstudentpromotefilterForm({ course_id: res.course_id, academic_regulation_id: res.id });
        this.questions$.subscribe(q => this.questions = q);
        this.filtersectionForm = this.qcs.toFormGroup(this.questions as Inputfiledsbase<string>[]);
      this.getstudentdetails();
      });
    }

    // getSectionsDetails(): void {
    //   const data = {
    //     "id": this.BatchData.id,
    //     "code": this.BatchData.code
    //   }
    //   this.apiservice.getBatchDetails(data).subscribe((res: any) => {
    //     this.sectionData = res;
    //     this.questions$ = this.dataService.getRegulationstudentfilterForm({ course_id: res.course_id, academic_regulation_id: res.id, sections: res.sections });
    //     this.questions$.subscribe(q => this.questions = q);
    //     this.filtersectionForm = this.qcs.toFormGroup(this.questions as Inputfiledsbase<string>[]);
    //   })
    // }
  
    getstudentdetails( section_id?: number) {
      this.filters = {
        semester_id: this.academicsemisterdata.semester_id,
        section_id: section_id,
        academic_year_id: this.academicsemisterdata?.academic_year_id,
        academic_regulation_id: this.academicsemisterdata?.academic_regulation_id,
        course_id: this.academicsemisterdata?.course_id
      }
      this.apiservice.getacademicstudent(this.paginationdata, this.filters).subscribe((res: any) => {
        this.studentdataSource = new MatTableDataSource<Student>(res?.rows);
        this.total_count = res.total_count;
      });
    }
  
    isAllSelected() {
      const numSelected = this.selection.selected.length;
      const numRows = this.studentdataSource.data.length;
      return numSelected === numRows;
    }
  
    toggleAllRows() {
      if (this.isAllSelected()) {
        this.selection.clear();
        return;
      }
      this.selection.select(...this.studentdataSource.data);
    }
  
    checkboxLabel(row?: Student): string {
      if (!row) {
        return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
      }
      return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.index + 1}`;
    }
  
    logSelection() {
      // if (this.selection.selected.length > 0) {
      //   this.openCreateSectionDialog();
      //   this.addingsectionsdata = this.sectionData.sections.filter((item: any) => item.id != this.filtersectionForm.value.section_id);
      //   this.createsection$ = this.dataService.getassigntoSectionForm({ sections: this.addingsectionsdata });
      //   this.createsection$.subscribe(questions => this.createsection = questions);
      //   this.createsectionForm = this.qcs.toFormGroup(this.createsection as Inputfiledsbase<string>[]);
      // } else {
      //   this.assigntostudenterrormessage = 'Please select the students'
      // }
    }
  
    pagination(event: any) {
      this.paginationdata = event;
      this.filterStudents();
    }
  
    filterStudents() {
      const formValues = this.filtersectionForm.value;
      this.getstudentdetails(formValues.section_id);
    }
  
  
    setStep(index: number, semester: any) {
      this.step = index;
      this.selected_semesterData = semester;
      // this.getsemestersubjectsDetails(semester)
    }
  
  
    closeDialog(event: any) {
      this.dialog.closeAll();
      // const dialogRef = this.dialog.open(this.createSectionDialog);
      // this.getSectionsDetails();
      document
        .getElementsByClassName('animate__animated')[0]
        .classList.remove('animate__fadeIn');
      document
        .getElementsByClassName('animate__animated')[0]
        .classList.add('animate__fadeOut');
      setTimeout(() => {
        this.dialog.closeAll();
      }, 1000);
    }
  
    onSaveClick(): void {
      this.dialog.closeAll();
    }
  
    backPage(): void {
      this.router.navigate(['/academiccalendar']).then(() => {
        this.BatchData;
      });
    }
  
    onSubmit() {
      // const datastringfy =  JSON.stringify(this.createsectionForm.value.section_id);
      // const datapared = JSON.parse(datastringfy);
      this.datasend = {
        "students": this.selection.selected,
        "academic_year_id": this.academicsemisterdata.academic_year_id,
        "academic_regulation_id": this.academicsemisterdata.academic_regulation_id,
        "course_id": this.academicsemisterdata.course_id,
        "semester_id": this.academicsemisterdata.semester_id,
        // "section_name": this.createsectionForm.value.section_name
      };
      // this.assignstudentpromote(this.datasend);
    }
  
    assignstudentpromote() {
      this.datasend = {
        "students": this.selection.selected,
        "academic_year_id": this.academicsemisterdata.academic_year_id,
        "academic_regulation_id": this.academicsemisterdata.academic_regulation_id,
        "course_id": this.academicsemisterdata.course_id,
        "semester_id": this.academicsemisterdata.semester_id,
        // "section_name": this.createsectionForm.value.section_name
      };
      this.apiservice.AssignStudentpromote(this.datasend).subscribe(
        (res: any) => {
          if (res.code === 200 && res.status === true) {
            this.toastService.showToast('success', 'Saved Successfully');
            this.closeDialog(true);
          } else if (res.status === false) {
            this.toastService.showToast('danger', res.message);
          }
        },
        (error) => {
          this.toastService.showToast('warning', `Error: ${error.message}`);
        }
      );
    }
  
    createAPi(event: any) {
      this.apiservice.createacadamics(event).subscribe(
        (res: any) => {
          if (res.code === 201 && res.status === true) {
            this.toastService.showToast('success', 'Saved Successfully');
            this.closeDialog(true);
          } else if (res.status === false) {
            this.toastService.showToast('danger', res.message);
          }
        },
        (error) => {
          this.toastService.showToast('warning', `Error: ${error.message}`);
        }
      );
    }
    
}
